import angular from "angular";
import InstructorSignupController from "./instructor-signup.controller";
import template from "./instructor-signup.html";
import "../../../assets/images/logo-for-wht-bg.svg";
function config($stateProvider, $urlRouterProvider) {
  $stateProvider.state("drivecoach.signup.instructor", {
    url: "/instructor",
    controller: InstructorSignupController,
    controllerAs: "vm",
    template: template,
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];

export default angular
  .module("signup.instructor", [])
  .config(config)
  .controller("InstructorSignupController", InstructorSignupController);
